import React, {useState} from "react";
import './AboutNews.css';
import Blog from "./NewsBlog";

// Мы передаем в компонент year текущий год, ArrayOfAllNews - массив всех новостей AllPageText - Название месяцев

function CompanyNewsComponent(props){
        const [RBCNewsYear, setRBCNewsYear] = useState(2025);
        const [RBCNewsYear2025, setRBCNewsYear2025] = useState(true);
        const [RBCNewsYear2024, setRBCNewsYear2024] = useState(false);
        const [RBCNewsYear2023, setRBCNewsYear2023] = useState(false);
        const [RBCNewsYear2022, setRBCNewsYear2022] = useState(false);
        const [RBCNewsYear2021, setRBCNewsYear2021] = useState(false);
        const [RBCNewsYear2020, setRBCNewsYear2020] = useState(false);
        const [RBCNewsYear2019, setRBCNewsYear2019] = useState(false);
        const [RBCNewsYear2018, setRBCNewsYear2018] = useState(false);
        const [RBCNewsYear2017, setRBCNewsYear2017] = useState(false);
        const [RBCNewsYear2016, setRBCNewsYear2016] = useState(false);
        const [RBCNewsYear2015, setRBCNewsYear2015] = useState(false);
        const [RBCNewsYear2014, setRBCNewsYear2014] = useState(false);
        const [RBCNewsYear2013, setRBCNewsYear2013] = useState(false);
        const [RBCNewsYear2012, setRBCNewsYear2012] = useState(false);
        const [RBCNewsYear2011, setRBCNewsYear2011] = useState(false);
        const [RBCNewsYear2010, setRBCNewsYear2010] = useState(false);
        const [RBCNewsYear2009, setRBCNewsYear2009] = useState(false);
        const [RBCNewsYear2008, setRBCNewsYear2008] = useState(false);


    function RBCNewsYearSet(year) {
        setRBCNewsYear(year);
        setRBCNewsYear2025(false);
        setRBCNewsYear2024(false);
        setRBCNewsYear2023(false);
        setRBCNewsYear2022(false);
        setRBCNewsYear2021(false);
        setRBCNewsYear2020(false);
        setRBCNewsYear2019(false);
        setRBCNewsYear2018(false);
        setRBCNewsYear2017(false);
        setRBCNewsYear2016(false);
        setRBCNewsYear2015(false);
        setRBCNewsYear2014(false);
        setRBCNewsYear2013(false);
        setRBCNewsYear2012(false);
        setRBCNewsYear2011(false);
        setRBCNewsYear2010(false);
        setRBCNewsYear2009(false);
        setRBCNewsYear2008(false);

        if (year === 2025) { setRBCNewsYear2025(true);
        } else if (year === 2024) {setRBCNewsYear2024(true);
        } else if (year === 2023) {setRBCNewsYear2023(true);
        } else if (year === 2022) {setRBCNewsYear2022(true);
        } else if (year === 2021) {setRBCNewsYear2021(true);
        } else if (year === 2020) {setRBCNewsYear2020(true);
        } else
        if (year === 2019) {setRBCNewsYear2019(true);
        } else
        if (year === 2018) {setRBCNewsYear2018(true);
        } else
        if (year ===2017) {setRBCNewsYear2017(true);
        } else
        if (year ===2016) {setRBCNewsYear2016(true);
        } else
        if (year ===2015) {setRBCNewsYear2015(true);
        } else
        if (year ===2014) {setRBCNewsYear2014(true);
        } else
        if (year ===2013) {setRBCNewsYear2013(true);
        } else
        if (year ===2012) {setRBCNewsYear2012(true);
        } else
        if (year ===2011) {setRBCNewsYear2011(true);
        } else
        if (year ===2010) {setRBCNewsYear2010(true);
        } else
        if (year ===2009) {setRBCNewsYear2009(true);
        } else
        if (year ===2008) {setRBCNewsYear2008(true);
        }
    }

        //console.log('FilteredNewsArr',props.ArrayOfAllNews);
        let FilteredNewsArr = props.ArrayOfAllNews.filter(((value) => {
            //console.log('value.year',value.NewsDate.substr(1,4), RBCNewsYear);
            return value.NewsDate.substr(0,4) === ''+RBCNewsYear})
        );
        let classNameDiv2025='AboutNewsYearElement';
        let classNameDiv2024='AboutNewsYearElement';
        let classNameDiv2023='AboutNewsYearElement';
        let classNameDiv2022='AboutNewsYearElement';
        let classNameDiv2021='AboutNewsYearElement';
        let classNameDiv2020='AboutNewsYearElement';
        let classNameDiv2019='AboutNewsYearElement';
        let classNameDiv2018='AboutNewsYearElement';
        let classNameDiv2017='AboutNewsYearElement';
        let classNameDiv2016='AboutNewsYearElement';
        let classNameDiv2015='AboutNewsYearElement';
        let classNameDiv2014='AboutNewsYearElement';
        let classNameDiv2013='AboutNewsYearElement';
        let classNameDiv2012='AboutNewsYearElement';
        let classNameDiv2011='AboutNewsYearElement';
        let classNameDiv2010='AboutNewsYearElement';
        let classNameDiv2009='AboutNewsYearElement';
        let classNameDiv2008='AboutNewsYearElement';
        if (RBCNewsYear2025) {classNameDiv2025='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2024) {classNameDiv2024='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2023) {classNameDiv2023='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2022) {classNameDiv2022='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2021) {classNameDiv2021='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2020) {classNameDiv2020='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2019) {classNameDiv2019='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2018) {classNameDiv2018='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2017) {classNameDiv2017='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2016) {classNameDiv2016='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2015) {classNameDiv2015='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2014) {classNameDiv2014='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2013) {classNameDiv2013='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2012) {classNameDiv2012='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2011) {classNameDiv2011='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2010) {classNameDiv2010='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2009) {classNameDiv2009='AboutNewsYearElement AboutNewsYearElementActive'}
        if (RBCNewsYear2008) {classNameDiv2008='AboutNewsYearElement AboutNewsYearElementActive'}

        return (
            <div className="AboutNewsThisOut">
                <div className="AboutNewsThis">
                    <div className="AboutNewsYear">
                        <div className={classNameDiv2025} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2025)}>2025</div>
                        <div className={classNameDiv2024} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2024)}>2024</div>
                        <div className={classNameDiv2023} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2023)}>2023</div>
                        <div className={classNameDiv2022} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2022)}>2022</div>
                        <div className={classNameDiv2021} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2021)}>2021</div>
                        <div className={classNameDiv2020} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2020)}>2020</div>
                        <div className={classNameDiv2019} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2019)}>2019</div>
                        <div className={classNameDiv2018} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2018)}>2018</div>
                        <div className={classNameDiv2017} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2017)}>2017</div>
                        <div className={classNameDiv2016} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2016)}>2016</div>
                        <div className={classNameDiv2015} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2015)}>2015</div>
                        <div className={classNameDiv2014} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2014)}>2014</div>
                        <div className={classNameDiv2013} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2013)}>2013</div>
                        <div className={classNameDiv2012} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2012)}>2012</div>
                        <div className={classNameDiv2011} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2011)}>2011</div>
                        <div className={classNameDiv2010} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2010)}>2010</div>
                        <div className={classNameDiv2009} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2009)}>2009</div>
                        <div className={classNameDiv2008} role = "button" tabIndex={0} onClick={() => RBCNewsYearSet(2008)}>2008</div>

                    </div>
                    <Blog posts={FilteredNewsArr} lang={props.lang}/>


                </div>
            </div>
    )}

export default CompanyNewsComponent
